import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";

const ESSOverviewSummary: React.FC = () => {
  const [monthOpen, setMonthOpen] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  const [employeeOpen, setEmployeeOpen] = useState(false);

  const toggleMonth = () => setMonthOpen(!monthOpen);
  const toggleStatus = () => setStatusOpen(!statusOpen);
  const toggleEmployee = () => setEmployeeOpen(!employeeOpen);

  return (
    <Container className="my-4">
      <PageHeader
        title="ESS Overview"
        buttons={[
          // {
          //   label: "+ Add Announcements",
          //   onClick: () => handleAddAnnouncements(),
          //   color: "#43B9B2",
          // },
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />
      <div className="p-4 bg-white shadow rounded">
        <Row className="mb-3">
          <Col xs="6">
            <h5>Summary Report | December 2024</h5>
          </Col>
          <Col xs="6" className="text-end">
            <RoundedDropdown
              options={[]}
              onSelect={(e) => console.log("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Month"
              headingColor="#2e8dd3"
            />

            <RoundedDropdown
              options={[]}
              onSelect={(e) => console.log("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Status"
              headingColor="#2e8dd3"
            />

            <RoundedDropdown
              options={[]}
              onSelect={(e) => console.log("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Employee"
              headingColor="#2e8dd3"
            />
          </Col>
        </Row>

        <Table bordered>
          <tbody>
            <tr>
              <td>
                <strong>Employee Name</strong>
              </td>
              <td>AHSAN ALI NAGOO</td>
            </tr>
            <tr>
              <td>
                <strong>Employee Code</strong>
              </td>
              <td>881024</td>
            </tr>
            <tr>
              <td>
                <strong>Designation</strong>
              </td>
              <td>Probationary MR</td>
            </tr>
            <tr>
              <td>
                <strong>State</strong>
              </td>
              <td>KASHMIR</td>
            </tr>
            <tr>
              <td>
                <strong>Head Quarter/ Location</strong>
              </td>
              <td>SRINAGAR | KASHMIR</td>
            </tr>
            <tr>
              <td>
                <strong>Currency</strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <strong>Working Status</strong>
              </td>
              <td>
                <Badge color="success">Yes</Badge>
              </td>
            </tr>
          </tbody>
        </Table>

        <Table bordered responsive>
          <thead className="text-center">
            <tr>
              <th>Particulars</th>
              <th>Claimed Amount</th>
              <th>Total Amount</th>
              <th>Change by Approver</th>
              <th>Net Payable Amount</th>
              <th>Auditor Change Amount</th>
              <th>Auditor's Add Amount</th>
              <th>Final Payable Amount</th>
              <th>Company Card</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <tr>
              <td>DA-OS</td>
              <td>7650</td>
              <td>7650</td>
              <td>-7200</td>
              <td>450</td>
              <td>0</td>
              <td>7200</td>
              <td>7650</td>
              <td>0</td>
            </tr>
            <tr>
              <td>TA</td>
              <td>0</td>
              <td>0</td>
              <td>+1000</td>
              <td>1000</td>
              <td>0</td>
              <td>0</td>
              <td>1000</td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <strong>Total</strong>
              </td>
              <td>7650</td>
              <td>7650</td>
              <td>6200</td>
              <td>1450</td>
              <td>0</td>
              <td>0</td>
              <td>8650</td>
              <td>0</td>
            </tr>
          </tbody>
        </Table>

        <Row className="mt-2">
          <Col xs="6">
            <strong>Final Payable Amount ()</strong>
          </Col>
          <Col xs="6" className="text-end">
            <strong>8650</strong>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ESSOverviewSummary;
